import { format, parse } from 'date-fns'
import { mapState } from 'vuex'

const toIsoDate = (value) =>
  format(parse(value, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd')

export default {
  components: {
    HeaderBlock: () => import('~/components/commom/header/index'),
    ButtonBlock: () => import('~/components/commom/button-block/index'),
    HealthInsuranceForm: () =>
      import('~/components/layouts/health-insurance-form/index')
  },
  async fetch({ store }) {
    if (store.state.team.members.length === 0) {
      await store.dispatch('team/getTeam')
    }
  },
  data() {
    return {
      activeStep: 0,
      healthData: {},
      isSending: false
    }
  },
  computed: {
    ...mapState(['auth']),
    teamMember() {
      return this.$store.state.team.members[0]
    },
    simulationData() {
      const extraProponentsDob = this.healthData.insured_dob_all
        ? Object.values(this.healthData.insured_dob_all).map(toIsoDate)
        : undefined

      return {
        name: `${this.healthData.firstName} ${this.healthData.lastName}`.trim(),
        email: this.healthData.email,
        phone: this.healthData.phone.toString(),
        dob: toIsoDate(this.healthData.insuredDob),
        zipCode: this.healthData.postalCode,
        numberOfProponents: this.healthData.numberOfApplicants,
        extraProponentsDob,
        selectedPlanTypeId: this.healthData.planType
      }
    }
  },

  methods: {
    isStepActive(index) {
      return index === this.activeStep
    },

    goToNextStep() {
      this.$gtm.pushEvent({
        event:
          this.activeStep === 0
            ? 'health_simulation_start'
            : 'health_simulation_completed'
      })

      this.activeStep++
      window.scrollTo(0, 0)
    },

    submitForm() {
      if (this.isSending) {
        return
      }

      this.isSending = true

      this.sendToServer()
        .then((response) => {
          this.isSending = false

          this.$gtm.pushEvent({
            event: 'health_simulation'
          })

          return this.handleSucessSubmission(response.data)
        })
        .catch((_error) => {
          this.isSending = false
        })
    },

    sendToServer() {
      return this.$axios.post('health-insurance/quotes', this.simulationData, {
        baseURL: process.env.API_V2_BASE_URL,
        headers: {
          'Content-type': 'application/json; charset=utf-8'
        },
        withCredentials: true
      })
    },

    handleSucessSubmission(response) {
      this.saveSimulationOnStorage(response.uuid)
      this.saveSimulationData(this.simulationData)
      this.$router.push(
        this.localePath({
          name: 'simulacao-seguro-saude-resultados-id',
          params: {
            id: response.uuid
          }
        })
      )
    },
    saveSimulationData(simulationData) {
      return this.$store.commit('localStorage/SAVE_SIMULATION_DATA', {
        simulationData
      })
    },
    saveSimulationOnStorage(id) {
      if (this.auth.isLoggedIn) {
        return
      }

      return this.$store.commit(
        'localStorage/ADD_ANONYMOUS_HEALTH_SIMULATION',
        {
          id
        }
      )
    }
  }
}
